import React from 'react';
import { Asset } from 'expo-asset';
import { View } from 'react-native';
import MomentAtmosphere from './MomentAtmosphere';

const MOMENTS = {
  family: {
    full: Asset.fromModule(require('@/assets/images/landing-life-family.webp')).uri,
    narrow: Asset.fromModule(require('@/assets/images/landing-life-family-1000w.webp')).uri,
    label: 'A dad plays catch with his children while a robot works at a laptop on the porch.',
  },
  picnic: {
    full: Asset.fromModule(require('@/assets/images/landing-life-picnic.webp')).uri,
    narrow: Asset.fromModule(require('@/assets/images/landing-life-picnic-1000w.webp')).uri,
    label: 'A family enjoys a mountain picnic while their robot works at a nearby table.',
  },
  garden: {
    full: Asset.fromModule(require('@/assets/images/landing-life-garden.webp')).uri,
    narrow: Asset.fromModule(require('@/assets/images/landing-life-garden-1000w.webp')).uri,
    label: 'A dad and his children tend their garden while a robot handles work at a potting bench.',
  },
};

const imageStyle = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  imageRendering: 'pixelated',
};

/** Mid-page interludes: WebP srcset so phones skip the 1916px master. */
export default function LivingMoment({ scene }) {
  const moment = MOMENTS[scene];
  const srcSet = `${moment.narrow} 1000w, ${moment.full} 1916w`;
  return (
    <View nativeID={`landing-life-${scene}`} style={{ width: '100%', aspectRatio: 1916 / 821, position: 'relative', overflow: 'hidden', backgroundColor: '#40644A' }}>
      <img src={moment.full} srcSet={srcSet} sizes="100vw" alt={moment.label} decoding="async" style={imageStyle} />
      <MomentAtmosphere scene={scene} />
    </View>
  );
}
